import { ReactNode } from 'react'
import { CheckCircle2 } from 'lucide-react'

import { AuthLayout } from './AuthLayout'

interface AuthSuccessProps {
  title: ReactNode
  text: ReactNode
  footer?: ReactNode
}

export function AuthSuccess({ title, text, footer }: AuthSuccessProps) {
  return (
    <AuthLayout title="" footer={footer}>
      <div className="flex flex-col items-center text-center">
        <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-primary/10">
          <CheckCircle2 className="h-12 w-12 text-primary" strokeWidth={1.75} />
        </div>
        <h1 className="font-display text-3xl font-bold text-ink">{title}</h1>
        <div className="mt-3 text-base text-muted-foreground">{text}</div>
      </div>
    </AuthLayout>
  )
}
